import React, { forwardRef, useRef } from 'react';
import clsx from 'clsx';
import { Button } from '../Button';
import { Icon } from '../Icon';
import CheckFilled from '@mollie/ui-assets/icons/utilitarian/CheckFilled';
import Close from '@mollie/ui-assets/icons/utilitarian/Close';
import CloseFilled from '@mollie/ui-assets/icons/utilitarian/CloseFilled';
import WarningFilled from '@mollie/ui-assets/icons/utilitarian/WarningFilled';
import Loader from '@mollie/ui-assets/icons/utilitarian/Loader';
import { Box } from '../Box';
import { useCurrent, useDocumentListener, useStableCallback, } from '../../utils';
import './Toast.css';
export const Toast = forwardRef(function Toast(props, ref) {
    const { children, elementType = 'div', className, dismissable, variant, ariaCloseLabel = 'Close', onClose, loading, prefix, postfix, ...rest } = props;
    const currentVariant = useCurrent(variant);
    const currentScrollPosition = useRef((window === null || window === void 0 ? void 0 : window.scrollY) || 0);
    const stableOnClose = useStableCallback(onClose);
    useDocumentListener('scroll', () => {
        if (currentVariant.current !== 'notification') {
            return;
        }
        if (currentScrollPosition.current > window.scrollY &&
            window.scrollY < 100) {
            stableOnClose();
        }
        currentScrollPosition.current = window.scrollY;
    });
    return (React.createElement(Box.Restricted, { ...rest, elementType: elementType, className: clsx('mollie-ui-toast', { [`mollie-ui-toast--${variant}`]: variant }, className), ref: ref },
        {
            positive: (React.createElement(Icon, { src: CheckFilled, className: "mollie-ui-toast-icon" })),
            negative: (React.createElement(Icon, { src: CloseFilled, className: "mollie-ui-toast-icon" })),
            warning: (React.createElement(Icon, { src: WarningFilled, className: "mollie-ui-toast-icon" })),
            loading: (React.createElement(Icon, { src: Loader, spinning: true, className: "mollie-ui-toast-icon" })),
            neutral: null,
            notification: null,
            prefix,
        }[loading ? 'loading' : prefix ? 'prefix' : variant || 'neutral'],
        children && React.createElement("div", { className: "mollie-ui-toast-content" }, children),
        postfix && React.createElement("div", { className: "mollie-ui-toast-postfix" }, postfix),
        dismissable && (React.createElement(Button, { transparent: true, variant: "icon", size: "extra-small", "aria-label": ariaCloseLabel, onClick: (e) => {
                e.stopPropagation();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }, className: "mollie-ui-toast-button" },
            React.createElement(Icon, { src: Close })))));
});
Toast.displayName = 'Toast';
//# sourceMappingURL=Toast.js.map